import { useState, useRef, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { MagnifyingGlassIcon, XMarkIcon } from '@heroicons/react/24/outline'
import { setFilters } from './documentsSlice'

export default () => {
  const dispatch = useDispatch()
  const [isSearchVisible, setIsSearchVisible] = useState(false)
  const [searchQuery, setSearchQuery] = useState('')
  const searchInputRef = useRef(null)

  // TODO mettre un élément visuel montrant que la recherche est en cours
  const toggleSearch = (e) => {
    e.preventDefault()
    e.stopPropagation()
    if(isSearchVisible && searchQuery) {
      dispatch(setFilters({term: ''}))
      setSearchQuery('')
    }
    setIsSearchVisible(!isSearchVisible)
  }

  const handleSearch = (e) => {
    e.preventDefault()
    e.stopPropagation()
    dispatch(setFilters({term: searchQuery}))
  }

  // Focus sur l'input quand il devient visible
  useEffect(() => {
    if (isSearchVisible && searchInputRef.current) {
      setTimeout(() => {
        searchInputRef.current.focus()
      }, 300) // Attendre que l'animation soit terminée
    }
  }, [isSearchVisible])

  return (
    <div className="flex items-center justify-end">
      <div className={`flex items-center transition-all duration-300 ease-in-out overflow-hidden ${isSearchVisible ? 'w-80 opacity-100 mr-2' : 'w-0 opacity-0'}`}>
        <form onSubmit={handleSearch} className="flex items-center w-full">
          <div className="relative w-full">
            <input
              ref={searchInputRef}
              type="search"
              className="input input-bordered w-full pr-10 h-10 focus:outline-none"
              placeholder="Recherche de documents"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <button
              type="submit"
              className="absolute inset-y-0 right-0 z-1 h-full flex items-center px-3 btn btn-primary btn-sm"
              aria-label="Rechercher"
            >
              <MagnifyingGlassIcon className="w-4 h-4" />
            </button>
          </div>
        </form>
      </div>
      <button
        className='btn btn-square btn-ghost p-2'
        onClick={toggleSearch}
        title={isSearchVisible ? "Fermer et annuler la recherche" : "Ouvrir la recherche"}
      >
        { isSearchVisible ? <XMarkIcon/> : <MagnifyingGlassIcon/>}
      </button>
    </div>
  )
}